<template>
    <div id="main" v-if="isActiveSection">
      <div class="venue" v-if="venue.banner">
        <img :src="venue.banner" />
        <button class="venue-btn">
          {{ venue.name }}
        </button>
      </div>
      <div class="city-info mb-1" v-if="venue.id">
        <p class="city-text">
          <i id="ven-icon" class="fa fa-map-marker" aria-hidden="true"></i>
          &nbsp; {{ venue.address }}
        </p>
        <p class="city-text">
          <i id="ven-icon" class="fa fa-phone" aria-hidden="true"></i>
          &nbsp; {{ venue.phone_number }}
        </p>
        <p class="city-text">
          <i id="ven-icon" class="fa fa-globe" aria-hidden="true"></i>
          &nbsp;
          <a :href="venue.website" target="_blank" class="venue-link">
           {{ venue.name }}
          </a>

        </p>
        <p class="city-text">
          <i id="ven-icon" class="fa fa-envelope" aria-hidden="true"></i>
          &nbsp;
          <a :href="'mailto:' + venue.email" target="_blank" class="venue-link">
            {{venue.email}}
          </a>
        </p>
      </div>
      <div class="aboutTheCity" v-if="(venue.about_city || venueCityImages.length) && !isMobileScreen">
        <h1 class="heading">About the city</h1>
      </div>
      <div class="venue-container" v-if="!isMobileScreen">
        <b-container class="bv-example-row">
          <b-row>
            <div class="single-event-venue-image-slider">
              <b-carousel
                v-if="venueCityImages.length"
                id="carousel-1"
                v-model="slide"
                :interval="4000"
                controls
                indicators
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  v-for="venCityImages in venueCityImages"
                  :key="venCityImages.id"
                  :img-src="venCityImages.image"
                ></b-carousel-slide>

                <b-carousel-slide
                  :img-src="venue.banner"
                ></b-carousel-slide>
              </b-carousel>
            </div>
              <p class="venue-paragraph" v-html="venue.about_city" v-if="venue.about_city"></p>
          </b-row>
        </b-container>
      </div>
      <b-card v-else no-body class="mt-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
        <div v-b-toggle="'accordion-city'" class="visaInfoHeader text-center">
          ABOUT THE CITY
          <i class="fas fa-chevron-up" />
          <i class="fas fa-chevron-down" />
        </div>
        </b-card-header>
        <b-collapse id="accordion-city" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <div class="single-event-venue-image-slider">
              <b-carousel
                v-if="venueCityImages.length"
                id="carousel-1"
                v-model="slide"
                :interval="41000"
                controls
                indicators
                background="#fff"
                img-width="1024"
                img-height="480"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  v-for="venCityImages in venueCityImages"
                  :key="venCityImages.id"
                  :img-src="venCityImages.image"
                ></b-carousel-slide>

                <b-carousel-slide
                  :img-src="venue.banner"
                ></b-carousel-slide>
              </b-carousel>
            </div>
            <p class="venue-paragraph" v-html="venue.visa_info"></p>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card v-if="venue.visa_info" no-body class="mt-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
        <div v-b-toggle="'accordion-visa'" class="visaInfoHeader text-center">
          Visa & Travel Info
          <i class="fas fa-chevron-up" />
          <i class="fas fa-chevron-down" />
        </div>
        </b-card-header>
        <b-collapse id="accordion-visa" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="venue-paragraph" v-html="venue.visa_info"></p>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Venue',

  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  async mounted() {
    if (this.$route.params.eventId) {
      await this.fetchVenue(this.$route.params.eventId);
      await this.fetchVenueCityImages(this.$route.params.eventId);
    }
  },

  methods: {
    ...mapActions({
      fetchVenue: 'events/fetchVenue',
      fetchVenueCityImages: 'events/fetchVenueCityImages',
    }),
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
  computed: {
    ...mapGetters({
      venue: 'events/fetchVenue',
      venueCityImages: 'events/fetchVenueCityImages',
      event: 'events/fetchEvent',
      isMobileScreen: 'isMobileScreen',
    }),
    isActiveSection() {
      return this.event && this.event.available_sections ? this.event.available_sections.includes('venue') : false;
    },
  },
};
</script>

<style scoped>
.venue {
  width: 100%;
}
.venue > img {
  width: 100%;
  height: 251px;
  object-fit: cover;
  border-radius: 0 10px 0 0;
}
.city-text {
  background-color: #ffffff;
  color: #BD9D5F;
  font-size: 13px;
  margin: 0;
  margin-top: 4px;
}
.aboutTheCity {
  background-color: rgb(255, 255, 255);
  text-align: center;
  padding: 17px 1px 17px 0px;
  margin: 0 0 1px 0;
  border-radius: 0 10px 0 0;
}
.heading {
  font-size: 20px;
  color: #333333;
  text-transform: uppercase;
  text-align: center;
}
.visa-info .heading {
  padding: 23px 0;
  background-color: #ffffff;
  border-radius: 0 10px 0 0;
  margin-bottom: 1px;
}
.visa-heading {
  text-align: center;
  color: #333333;
}

#accordion-visa {
    border-top: 1px solid #ebebeb;
}

.visa-info .venue-paragraph {
    background-color: #ffffff;
    border-radius: 0 0 10px 10px;
}

.venue-container {
  background-color: #ffffff;
  padding: 14px 1px 7px 1px;
  border-radius: 0 0 10px 10px;
  margin-bottom: 20px;
}
.city-info {
  background-color: #ffffff;
  padding: 12px;
}
.city-info.mb-1 {
    margin-bottom: 15px !important;
    border-radius: 0 0 10px 10px;
}
.venue-paragraph {
  color: #707070;
  font-size: 13px;
  padding: 15px;
  margin-bottom: 0;
}
#ven-icon {
  color: #333333;
}
.venue-btn {
  padding: 11px 20px 9px;
  background-color: #ebebeb;
  border: unset;
  position: absolute;
  top: 474px;
  z-index: 111;
  left: 12px;
  text-transform: uppercase;
}
/* media mobile */
@media (max-width: 1024px) {
  .venue-btn {
    top: unset;
    bottom: 30px;
  }
  .visa-info {
    margin-top: 10px;
  }
}
#carousel-1 {
  width: 350px;
  float: right;
  margin: 10px 55px 10px 125px;
}
.venue-link {
  color: #BD9D5F;
}
@media (max-width: 1024px) {
  .venue {
    border-radius: 0 10px 0 0;
    overflow: hidden;
    position: relative;
  }
  .city-info {
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    padding: 8px;
  }
  .city-text {
    font-size: 11px;
  }
  .venue-btn {
    left: 0;
  }

  .card {
    border: none !important;
    border-radius: 10px;
    overflow: hidden;
  }
  .card-header {
    background: transparent;
    columns: #333;
    padding: 0;
    border-bottom: unset;
  }
  .card-header .visaInfoHeader {
    padding: 12px 4px;
    margin: 0;
    font-weight: 600;
  }
  .card-body {
    padding: 0;
    border-top: 1px solid #ebebeb;
  }
  .card > header i {
    position: absolute;
    top: 16px;
    right: 20px;
  }
  header .fa-chevron-up {
    display: inline-block;
  }
  header .fa-chevron-down {
    display: none;
  }
  .card > header > .collapsed > .fa-chevron-down {
    display: inline-block;
  }
  .card > header > .collapsed > .fa-chevron-up {
    display: none;
  }

  .card-header .visaInfoHeader {
    text-transform: uppercase;
  }
}
</style>
<style>
  .single-event-venue-image-slider .img-fluid {
  max-width: 100%;
  height: 200px;
  object-fit: fill;
}
.single-event-venue-image-slider {
  display: flex;
  justify-content: center;
}
#carousel-1 {
  /* max-width: 400px; */
  padding: 10px;
}
</style>
